import { login as userLogin } from '../api/auth';
import { ADD_CUSTOMER_DATA } from './customer';
import { ADD_SPORT_DATA } from './sport';
import { ADD_USER_DATA } from './user';

const ADD_AUTH_DATA = 'ADD_AUTH_DATA';
const ADD_AUTH_ERROR = 'ADD_AUTH_ERROR';
const ADD_QLIK_TOKEN = 'ADD_QLIK_TOKEN';
const ADD_AUTH_TOKEN = 'ADD_AUTH_TOKEN';

const INITIAL_STATE = {
  error: '',
  expire: '',
  isAdmin: '',
  token: '',
  qlikToken: '',
  authToken: '',
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_AUTH_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_QLIK_TOKEN:
      return {
        ...state,
        qlikToken: action.payload,
      };
    case ADD_AUTH_TOKEN:
      return {
        ...state,
        authToken: action.payload,
      };
    case ADD_AUTH_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}

export function login(email, password) {
  return async (dispatch) => {
    try {
      const {
        expire, isAdmin, token, customer, sport, user, qlikToken, authToken,
      } = await userLogin(
        email,
        password,
      );

      dispatch({
        type: ADD_AUTH_DATA,
        payload: {
          expire,
          isAdmin,
          token,
        },
      });

      dispatch({
        type: ADD_CUSTOMER_DATA,
        payload: customer,
      });

      dispatch({
        type: ADD_SPORT_DATA,
        payload: sport,
      });

      dispatch({
        type: ADD_USER_DATA,
        payload: user,
      });

      dispatch({
        type: ADD_QLIK_TOKEN,
        payload: qlikToken,
      });

      dispatch({
        type: ADD_AUTH_TOKEN,
        payload: authToken,
      });

      return Promise.resolve({
        expire, isAdmin, token, customer, sport, user, qlikToken, authToken,
      });
    } catch (error) {
      const errorMsg = 'AccountLogin.Messages.InvalidCredentials';
      dispatch({
        type: ADD_AUTH_ERROR,
        payload: errorMsg,
      });
      return Promise.reject(errorMsg);
    }
  };
}
